'use strict';

(function () {

  angular.module('specsguardApp')
    .config(ProjectConfig);

  ProjectConfig.$inject = ['$stateProvider'];

  function ProjectConfig ($stateProvider) {
    $stateProvider
      .state('project', {
        url: '/project/all',
        // templateUrl: 'app-legacy/project/project.html',
        controller: 'ProjectCtrl',
        controllerAs: '$ProjectCtrl',
        menu: {
          context: 'projects',
          icon: 'folder',
          title: '[Projectlijst]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          projects: ['ProjectDataservice', function (ProjectDataservice) {
            if (window.location.pathname === '/project/all') {
              /**
               * Forward to V2 projects page.
               */
              window.location.href = 'v2/projects';
            } else {
              /**
               * Because it's hard to catch the state for the new page,
               * the forward may be skipped. If so, it's done from the
               * ProjectCtrl Controller.
               */
              return ProjectDataservice.getProjectList();
            }
          }],
        }
      })

      .state('project/new', {
        url: '/project/new',
        templateUrl: 'app-legacy/project/new/project.new.html',
        controller: 'ProjectNewCtrl',
        menu: {
          context: 'addproject',
          icon: 'create_new_folder',
          title: '[Project toevoegen]'
        },
        authenticate: true,
        needRole: 5,
        resolve: {
          users: ['User', function (User) {
            return User.query({
              currentTenant: true,
            }).$promise;
          }],
          pveTemplates: ['PvETemplateAPI', function (PvETemplateAPI) {
            return PvETemplateAPI.query({}).$promise;
          }],
          buildingTemplates: ['BuildingTemplateAPI', function (BuildingTemplateAPI) {
            return BuildingTemplateAPI.query({}).$promise;
          }],
          userManagedProjects: ['ProjectDataservice', 'Auth', function (ProjectDataservice, Auth) {
            const userId = Auth.getCurrentUser()._id;

            if (Auth.getUserAccessLevel() < 8) {
              return ProjectDataservice.getManagedProjectsByUserId(userId, ['manager']);
            }

            return ProjectDataservice.getManagedProjectsByUserId(userId, ['admin']);
          }]
        }
      })

      .state('project/overview', {
        url: '/project/{project_id}/overview',
        templateUrl: 'app-legacy/project/overview/project.overview.html',
        controller: 'ProjectOverviewCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Project overzicht]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: []
            }
          }, {
            room: '/project/:id',
            includes: {
              path: [['element']]
            }
          }
        ],
        authenticate: true,
        needRole: 1,
        resolve: {
          // resolve project
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      })

      .state('project/info', {
        url: '/project/{project_id}/info',
        templateUrl: 'app-legacy/project/info/project.info.html',
        controller: 'ProjectInfoCtrl',
        controllerAs: '$ProjectInfoCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Projectinformatie]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: [['element']]
            }
          }, {
            room: '/project/:id',
            includes: {
              path: [['module']]
            }
          }
        ],
        authenticate: true,
        needRole: 1,
        params: {
          projectLevel: 'all',
          title: 'Projectinformatie',
          knowledgeLevel: null
        },
        resolve: {
          buildingTemplates: ['sg2BuildingTemplateService', function (sg2BuildingTemplateService) {
            return sg2BuildingTemplateService.resolve();
          }],
          commentCount: ['sg2ElementService', '$stateParams', function(sg2ElementService, $stateParams) {
            return sg2ElementService.resolveCommentCounts($stateParams.project_id);
          }],
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id, true);
          }],
          projectTemplates: ['sg2ProjectTemplateService', function (sg2ProjectTemplateService) {
            return sg2ProjectTemplateService.resolve();
          }],
          user: ['Auth', function(Auth) {
            return Auth.getCurrentUserResolver();
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      .state('project/buildingAdd', {
        url: '/project/{project_id}/building/new',
        templateUrl: 'app-legacy/project/building/buildingAdd/building.add.html',
        controller: 'BuildingAddCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Gebouw toevoegen]'
        },
        authenticate: true,
        needRole: 5,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
          buildingTemplates: ['BuildingTemplateAPI', function (BuildingTemplateAPI) {
            return BuildingTemplateAPI.query({}).$promise;
          }],
        }
      })

      .state('project/buildinginfo', {
        url: '/project/{project_id}/building/{building_id}/info',
        templateUrl: 'app-legacy/project/info/project.info.html',
        controller: 'ProjectInfoCtrl',
        controllerAs: '$ProjectInfoCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[BuildingName] - [Gebouwinformatie]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: [['element']]
            }
          }, {
            room: '/project/:id',
            includes: {
              path: [['building']]
            }
          }
        ],
        authenticate: true,
        needRole: 1,
        params: {
          projectLevel: 2,
          title: 'Gebouwinformatie',
          knowledgeLevel: null
        },
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      })

      .state('project/elements-legacy', {
        url: '/project/{project_id}/elements-legacy?filter_status',
        templateUrl: 'app-legacy/project/elements/elements.html',
        controller: 'ProjectElementCtrl',
        controllerAs: 'elementCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Specificaties]'
        },
        notifications: [{
          room: '/project/:id',
          includes: {
            path: [['element']]
          }
        }],
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id, true);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      // Elements
      // @todo Add query params (SPEC-2564)
      .state('project/elements', {
        url: '/project/{project_id}/elements?status',
        component: 'sg2ElementsViewComponent',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Specificaties]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id, true);
          }],
          commentCount: ['sg2ElementService', '$stateParams', function(sg2ElementService, $stateParams) {
            return sg2ElementService.resolveCommentCounts($stateParams.project_id);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      .state('project/elements/element', {
        url: '/project/{project_id}/elements/{elementCode}',
        component: 'sg2ElementViewComponent',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Element]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      .state('project/documents', {
        url: '/project/{project_id}/documents',
        templateUrl: 'app-legacy/project/documents/documents.html',
        controller: 'ProjectDocumentsCtrl',
        controllerAs: '$ProjectDocumentsCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Documents]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      })

      // WIP: New Filemanager page
      .state('project/filemanager', {
        url: '/project/{project_id}/filemanager',
        templateUrl: 'app-legacy/project/filemanager/filemanager.html',
        controller: 'ProjectFileManagerCtrl',
        controllerAs: '$ProjectFileManagerCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[FileManager]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      })

      .state('project/admin', {
        url: '/project/{project_id}/admin',
        component: 'sg2AdminToolsView',
        menu: {
          context: 'project',
          title: 'Admin tools',
          subtitle: 'Super secret admin page'
        },
        authenticate: true,
        needRole: 10,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }]
        }
      });
  }

})();
